import { Image } from '@outdoor-voices/ui';
import { memo } from 'react';
import cc from 'classcat';
import PropTypes from 'prop-types';
import css from './Image.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var DressImage = function DressImage(_ref) {
  var alt = _ref.alt,
      cls = _ref.cls,
      height = _ref.height,
      href = _ref.href,
      name = _ref.name,
      sizes = _ref.sizes,
      src = _ref.src,
      userHandle = _ref.userHandle,
      width = _ref.width;
  return /*#__PURE__*/_jsxs("div", {
    className: cc([css.image, cls]),
    "data-dress-image": "true",
    children: [/*#__PURE__*/_jsx("a", {
      "aria-label": "Click to view ".concat(name, ". Link opens in new tab."),
      href: href,
      rel: "noreferrer noopener",
      target: "_blank",
      children: /*#__PURE__*/_jsx(Image, {
        alt: "A person wearing ".concat(name, " in ").concat(alt),
        height: height,
        sizes: sizes,
        src: src,
        width: width,
        wrap: false
      })
    }), userHandle && /*#__PURE__*/_jsx("a", {
      "aria-label": "Click to view ".concat(userHandle, "'s instagram account. Link opens in new tab."),
      className: css.userHandle,
      href: "https://instagram.com/".concat(userHandle.replace('@', '')),
      target: "_blank",
      rel: "noreferrer noopener",
      children: userHandle
    })]
  });
};

DressImage.propTypes = {
  alt: PropTypes.string,
  cls: PropTypes.string,
  height: PropTypes.number,
  href: PropTypes.string,
  name: PropTypes.string,
  sizes: PropTypes.arrayOf(PropTypes.number),
  src: PropTypes.string,
  userHandle: PropTypes.string,
  width: PropTypes.number
};
export default /*#__PURE__*/memo(DressImage);